var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91671 3.50001C9.91671 5.11084 8.61087 6.41668 7.00004 6.41668C5.38921 6.41668 4.08337 5.11084 4.08337 3.50001C4.08337 1.88918 5.38921 0.583344 7.00004 0.583344C8.61087 0.583344 9.91671 1.88918 9.91671 3.50001Z",
    fill: "#5E6278"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9772 8.23945C10.6176 7.82255 9.99998 7.84403 9.51705 8.10836C8.76973 8.51741 7.91202 8.74997 7 8.74997C6.08798 8.74997 5.23027 8.51741 4.48295 8.10836C4.00001 7.84403 3.38241 7.82255 3.02284 8.23945C2.22963 9.15912 1.75 10.3569 1.75 11.6666V12.25C1.75 12.8943 2.27233 13.4166 2.91667 13.4166H11.0833C11.7277 13.4166 12.25 12.8943 12.25 12.25V11.6666C12.25 10.3569 11.7704 9.15912 10.9772 8.23945Z",
    fill: "#5E6278"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.00fa8cfd07b91bc7f42751eb90e1e480.svg";
export { ForwardRef as ReactComponent };